import type { AnnouncementFeed } from "@billiard/contracts";

export interface AnnouncementReminderSummary {
  totalOutstanding: number;
  unread: number;
  awaitingAcknowledgement: number;
  hasPinnedOutstanding: boolean;
}

export const ANNOUNCEMENT_REMINDER_MAX_REFRESH_MS = 60_000;
const ANNOUNCEMENT_EXPIRY_REFRESH_SAFETY_MS = 250;

export function announcementReminderRefreshInterval(feed: AnnouncementFeed | undefined): number {
  if (!feed) return ANNOUNCEMENT_REMINDER_MAX_REFRESH_MS;
  const generatedAt = Date.parse(feed.generatedAt);
  if (!Number.isFinite(generatedAt)) return ANNOUNCEMENT_REMINDER_MAX_REFRESH_MS;

  let nextRefreshMs = ANNOUNCEMENT_REMINDER_MAX_REFRESH_MS;
  for (const item of feed.items) {
    const expiresAt = Date.parse(item.announcement.expiresAt);
    if (!Number.isFinite(expiresAt) || expiresAt <= generatedAt) continue;
    nextRefreshMs = Math.min(
      nextRefreshMs,
      expiresAt - generatedAt + ANNOUNCEMENT_EXPIRY_REFRESH_SAFETY_MS,
    );
  }
  return nextRefreshMs;
}

export function summarizeAnnouncementReminder(feed: AnnouncementFeed): AnnouncementReminderSummary {
  let unread = 0;
  let awaitingAcknowledgement = 0;
  let hasPinnedOutstanding = false;

  for (const item of feed.items) {
    const outstanding = item.myDeliveryState !== "ACKNOWLEDGED";
    if (item.myDeliveryState === "PENDING" || item.myDeliveryState === "DELIVERED") {
      unread += 1;
    } else if (item.myDeliveryState === "READ") {
      awaitingAcknowledgement += 1;
    }
    if (outstanding && item.announcement.pinned) hasPinnedOutstanding = true;
  }

  return {
    totalOutstanding: unread + awaitingAcknowledgement,
    unread,
    awaitingAcknowledgement,
    hasPinnedOutstanding,
  };
}
